module.exports = __webpack_public_path__ + "static/P8-fee28072c175529dc44505277d920b75.jpeg";